import { render } from "./Testimonial3Page.vue?vue&type=template&id=b8b90834&scoped=true&ts=true"
import script from "./Testimonial3Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial3Page.vue?vue&type=script&lang=ts"

import "./Testimonial3Page.vue?vue&type=style&index=0&id=b8b90834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b90834"]])

export default __exports__